module.exports = __webpack_public_path__ + "static/img/xlh_logo.09184c93.jpg";